import { useState } from "react";
import { useContextSelector } from "use-context-selector";
import BetSlipContext from "../../context/BetSlipContext";
import RenderOddsBookmaker from "./RenderOddsBookmaker";
import { formatWithCommas } from "../../Utils/Toast";
import { useBookmakerLogic } from "../useLogic/useBookmakerLogic";
const Bookmaker = ({
  runner,
  backOdds,
  layOdds,
  oldBack,
  oldLay,
  profileData,
  marketName,
  detail,
  ms,
  typeGame,
  user,
  marketId,
  totalMatched,
  addToFavioute,
  position,
}) => {
  const showBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.showBetDialog;
  });

  const betSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betSlipObject;
  });

  const [active, setActive] = useState(true);
  const { localLimit, handelChange, checkArrays, fav } = useBookmakerLogic({
    backOdds,
    layOdds,
    oldBack,
    oldLay,
    profileData,
    marketName,
    detail,
    ms,
    typeGame,
    user,
    marketId,
    totalMatched,
    position,
  });

  return (
    <section>
      <div className="s-shadow-2sm s-rounded-b-5px">
        <div
          onClick={() => {
            setActive(!active);
          }}
          className="s-relative s-py-1.5 s-pr-9 s-pl-1.5 s-text-sm s-h-40px s-text-primary s-bg-primary s-rounded-5px s-cursor-pointer s-transition-all s-duration-300 s-flex s-items-center s-rounded-t-5px s-rounded-b-none"
        >
          <div className="s-flex s-justify-start s-items-center">
            <div
              data-v-5460a16b
              className="s-fav s-text-market-name dark:s-text-market-name s-text-15px s-text-market-name s-mr-4px s-ml-4px s-h-25px s-flex s-items-center -s-mt-1px"
            >
              <div
                data-v-5460a16b
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  addToFavioute(
                    detail?.eventId,
                    "Bookmaker",
                    detail?.bookmakerMarketId,
                    detail?.eventType
                  );
                }}
                className={`s-relative s-icon-star${
                  fav ? "-solid s-animate-star-line-box" : ""
                }`}
              >
                <span
                  data-v-5460a16b
                  className={`s-rating-star-line s-bg-market-name dark:s-bg-market-name ${
                    fav ? "s-animate-star-line" : ""
                  } `}
                />
                <span
                  data-v-5460a16b
                  className={`s-rating-star-line s-bg-market-name dark:s-bg-market-name ${
                    fav ? "s-animate-star-line" : ""
                  } `}
                />
                <span
                  data-v-5460a16b
                  className={`s-rating-star-line s-bg-market-name dark:s-bg-market-name ${
                    fav ? "s-animate-star-line" : ""
                  } `}
                />
              </div>
            </div>
            <div className="s-ml-2">
              <p className="-s-ml-4px s-text-16px s-font-bold s-text-market-name">
                Bookmaker
              </p>
            </div>
          </div>
          <span
            className={`s-icon-arrow-down-sencodary s-absolute s-right-4 s-text-12px s-text-market-name s-transition-transform s-origin-center s-duration-300 s-transform ${
              active ? "s-rotate-180" : ""
            }`}
          />
        </div>
        {active && (
          <div>
            <div className="s-rounded-b-lg">
              <div className="s-px-1 s-bg-white dark:s-bg-black-800 s-rounded-b-5px">
                <div className="s-py-1px s-flex s-justify-between s-items-center">
                  <div className="s-flex-1" />
                  <div className="s-w-129px s-flex s-gap-1px s-text-14px s-font-bold s-leading-140">
                    <div className="s-w-64px s-text-center s-text-global-font-default-light dark:s-text-global-font-default-dark">
                      Back
                    </div>
                    <div className="s-w-64px s-text-center s-text-global-font-default-light dark:s-text-global-font-default-dark">
                      Lay
                    </div>
                  </div>
                </div>
                <div data-v-635307b5>
                  <div
                    data-v-635307b5
                    className="s-relative s-flex s-items-center s-justify-center s-flex-col s-gap-1px"
                  >
                    {runner?.map((item, index) => {
                      const odds_back = backOdds?.filter(
                        (todd) =>
                          todd?.runnerName?.toLowerCase() ==
                          (item?.RunnerName?.toLowerCase() ||
                            item?.runnerName?.toLowerCase())
                      );
                      const odds_lay = layOdds?.filter(
                        (todd) =>
                          todd?.runnerName?.toLowerCase() ==
                          (item?.RunnerName?.toLowerCase() ||
                            item?.runnerName?.toLowerCase())
                      );
                      const old_back = oldBack?.filter(
                        (todd) =>
                          todd?.runnerName?.toLowerCase() ==
                          (item?.RunnerName?.toLowerCase() ||
                            item?.runnerName?.toLowerCase())
                      );
                      const old_lay = oldLay?.filter(
                        (todd) =>
                          todd?.runnerName?.toLowerCase() ==
                          (item?.RunnerName?.toLowerCase() ||
                            item?.runnerName?.toLowerCase())
                      );
                      let disabelBack =
                        "lockBackBets" in item ? item?.lockBackBets : false;
                      let disabelLay =
                        "lockLayBets" in item ? item?.lockLayBets : false;
                      let disableFull = checkArrays(
                        odds_back?.slice(0, 1),
                        odds_lay?.slice(0, 1),
                        localLimit
                      );
                      return (
                        <div data-v-635307b5 className="s-w-full">
                          <div
                            data-v-635307b5
                            className="s-w-full s-relative s-flex s-justify-start s-items-center s-bg-black-100 dark:s-bg-black-700"
                          >
                            <div
                              data-v-635307b5
                              className="s-px-2 s-h-full s-flex s-flex-1 s-flex-col s-justify-center"
                            >
                              <p
                                data-v-635307b5
                                className="s-text-17px s-font-bold s-leading-120 s-break-all s-text-global-font-default-light dark:s-text-global-font-default-dark"
                              >
                                {item?.RunnerName || item?.runnerName}
                              </p>
                              {Math.abs(item?.newPosition) >= 0 &&
                                showBetDialog &&
                                betSlipObject?.playType == "bookmaker" &&
                                marketId ==
                                  betSlipObject?.object?.newMarketId && (
                                  <div
                                    className="s-text-12px s-leading-150 s-flex"
                                    data-testid="forecast"
                                  >
                                    <span
                                      className={`s-flex s-items-center s-text-forecast-${
                                        item?.newPosition > 0 ? "up" : "down"
                                      }-text`}
                                      data-testid="estimate-forecast"
                                    >
                                      <span className="s-icon-arrow-left s-rotate-180 s-flex s-text-6px s-mx-0.5" />{" "}
                                      {item?.newPosition > 0
                                        ? Math.abs(item?.newPosition).toFixed(2)
                                        : `(${Math.abs(
                                            item?.newPosition
                                          ).toFixed(2)})`}
                                    </span>
                                  </div>
                                )}
                            </div>
                            <RenderOddsBookmaker
                              component={typeGame}
                              index={index}
                              marketName={marketName}
                              item={item}
                              disabelBack={disabelBack}
                              oldBack={old_back}
                              oldLay={old_lay}
                              disableFull={disableFull}
                              disabelLay={
                                detail?.market == "Win" ? true : disabelLay
                              }
                              isInPlay={
                                ["Win", "Winner"].includes(detail?.market)
                                  ? true
                                  : detail?.status == "in_play"
                                  ? true
                                  : false
                              }
                              handelChange={handelChange}
                              odds_lay={odds_lay}
                              odds_back={odds_back}
                              limit={localLimit}
                              ms={ms}
                              betType={betSlipObject?.betType}
                              active={
                                showBetDialog &&
                                marketId == betSlipObject?.newMarketId &&
                                item?.SelectionId ==
                                  betSlipObject?.object?.SelectionId &&
                                "bookmaker" == betSlipObject?.playType
                              }
                            />
                          </div>
                        </div>
                      );
                    })}
                    {ms != 1 && (
                      <div className="s-absolute s-right-0 s-top-0 s-flex s-justify-center s-items-center s-w-129px s-h-full s-bg-black-600 dark:s-bg-black-800 s-opacity-80 s-text-11px s-text-white s-rounded-3px s-z-20" />
                    )}
                  </div>
                  <div
                    data-v-635307b5
                    className="s-py-8px s-flex s-justify-end s-items-center"
                  >
                    <div
                      data-v-635307b5
                      className="s-flex s-gap-3px s-items-center s-text-black-600 dark:s-text-black-400"
                      data-testid="betLimit"
                    >
                      <span className="s-icon-min-max s-text-14px" />
                      <span className="s-text-12px">Min/Max</span>
                      <span className="s-text-12px s-font-bold">
                        {formatWithCommas(localLimit?.minAmount)}/
                        {formatWithCommas(localLimit?.maxAmount)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Bookmaker;
